import {useI18n} from '@yandex-delivery/core/i18n'
import {useAddNotification} from '@yandex-delivery/ui'
import {useQueryState} from '@yandex-delivery/utils'
import {useCallback, useMemo} from 'react'

import {type TariffsInfoByPaymentKind} from '../../../../../api'

const TAB_KEY = 'payment_kind'

export function useCargoInfoController(tariffsInfo: TariffsInfoByPaymentKind[]) {
  const tabs = useMemo(
    () =>
      tariffsInfo.map(({paymentKind, paymentKindTitle, disableReason}) => ({
        value: paymentKind,
        label: paymentKindTitle,
        disabled: !!disableReason,
      })),
    [tariffsInfo],
  )

  const [tabValue = tabs[0].value, setTabValue] = useQueryState(TAB_KEY)

  const blocks = useMemo(
    () => tariffsInfo.find(({paymentKind}) => paymentKind === tabValue)?.blocks,
    [tabValue, tariffsInfo],
  )

  return {
    tabs,
    tabValue,
    onTabValueChange: setTabValue,
    blocks,
  }
}

export function useDownloadErrorHandler() {
  const i18n = useI18n()
  const addNotification = useAddNotification()

  return useCallback(() => {
    addNotification(i18n('tariffs-v3.error.download-error', 'Не удалось загрузить файл, повторите позже'), {
      type: 'error',
    })

    return false
  }, [addNotification, i18n])
}
